import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function MerchantRegister() {
  const [form, setForm] = useState({ mobile: "", password: "", name: "", email: "", business_name: "" });
  const [busy, setBusy] = useState(false);
  const { registerMerchant } = useAuth();
  const navigate = useNavigate();

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await registerMerchant({ ...form, mobile: form.mobile.trim() });
      toast.success("Registration successful! Welcome to EPAYCASH");
      navigate("/merchant");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[hsl(210_40%_98%)]">
      <header className="border-b bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between">
          <Logo />
          <Link to="/login">
            <Button variant="ghost" data-testid="reg-login-link">Already have an account? Login</Button>
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 md:px-8 py-12">
        <div className="text-[10px] uppercase tracking-widest text-slate-500 font-medium">Self Registration</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight mt-2">
          Merchant बनें अपने business को <span className="text-[#f57320]">आगे बढ़ाएँ</span>
        </h1>
        <p className="text-sm text-slate-600 mt-3 max-w-2xl">Mobile + Password के साथ खाता बनाएँ. Registration के बाद KYC पूरा करें और सारी services access करें.</p>

        <div className="mt-8 bg-white border rounded-md p-6 md:p-8">
          <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <Label htmlFor="name">Full Name / नाम *</Label>
              <Input id="name" data-testid="reg-name-input" required value={form.name} onChange={upd("name")} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="mobile">Mobile / मोबाइल *</Label>
              <Input id="mobile" data-testid="reg-mobile-input" required inputMode="numeric" value={form.mobile} onChange={upd("mobile")} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="email">Email (optional)</Label>
              <Input id="email" data-testid="reg-email-input" type="email" value={form.email} onChange={upd("email")} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="business">Business Name / व्यवसाय का नाम</Label>
              <Input id="business" data-testid="reg-business-input" value={form.business_name} onChange={upd("business_name")} className="mt-1.5" />
            </div>
            <div className="md:col-span-2">
              <Label htmlFor="password">Password / पासवर्ड *</Label>
              <Input id="password" data-testid="reg-password-input" required type="password" value={form.password} onChange={upd("password")} className="mt-1.5" />
              <p className="text-xs text-slate-500 mt-1">Minimum 6 characters recommended.</p>
            </div>
            <div className="md:col-span-2 flex justify-end">
              <Button
                type="submit"
                disabled={busy}
                className="bg-orange-gradient hover:opacity-90 text-white rounded-full px-6 shadow-md shadow-[#f57320]/25"
                data-testid="reg-submit-btn"
              >
                {busy ? "Registering…" : "Register / रजिस्टर करें"}
              </Button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}
